import { render, staticRenderFns } from "./AccountSettingSportM8LimitSetting.vue?vue&type=template&id=68b797ea&"
import script from "./AccountSettingSportM8LimitSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSportM8LimitSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports